import React, { useEffect, useRef, useState } from "react";
import { Table, Input, Select, Button, Row, Col, Dropdown, message } from "antd";
import { SearchOutlined, DownOutlined, EditOutlined, LinkOutlined } from "@ant-design/icons";
import styled from "styled-components";
import COLORS from "common/Colors";
import { useHistory } from "react-router-dom";
import { CALL_API } from "common/API";
import { CSVLink } from "react-csv";
import { useSelector } from "react-redux";
import { getClientid, getUserList } from "redux/selectors";
import { ReactComponent as Editicon } from "../../assets/Edit_Pencil_01.svg";
import { kenyaFormatDateTime } from "utils/Date";
import { encrypt } from "common/Constants";

const { Option } = Select;

const ClientWrap = styled.div`
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    flex-wrap: wrap;
    gap: 10px;
    .btn-matter{
        color: #fff!important;
    }
    .export-btn{
         color: #000000 !important;
    border-color: #000000 !important;
    }
  }

  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.TEXT.PRIMARY};
  }

  .ant-table {
    border-radius: 8px;
  }

  .status-active {
    font-weight: 500;
  }

  .status-inactive {
    color: #6b7280;
    font-weight: 500;
  }
  .action-icon {
    opacity: 0;
    transition: all 0.2s ease;
    cursor: pointer;
  }

  .ant-table-tbody > tr:hover .action-icon {
    opacity: 1;
  }

  .action-icon:hover {
    color: ${COLORS.PRIMARY};
  }
  .filters-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    gap: 10px;
  }

  .total-count {
    font-weight: 600;
    font-size: 16px;
    color: ${COLORS.TEXT.PRIMARY};
  }

  /* Make filters aligned right */
  .filters {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 10px;
    flex-wrap: nowrap; /* 🚀 THIS STOPS WRAPPING */
  }

  .filter-input {
    min-width: 180px; /* 👈 prevents shrinking */
    max-width: 220px;
  }

  .filter-input.ant-input-affix-wrapper {
    border-radius: 20px !important;
    height: 38px !important;
    display: flex;
    align-items: center;
    padding: 0 11px;
    border: 1px solid #d9d9d9; /* ✅ restore proper border */
  }

  /* Remove only inner shadow/border safely */
  .filter-input.ant-input-affix-wrapper .ant-input {
    border: none !important;
    box-shadow: none !important;
  }

  .filter-input.ant-input-affix-wrapper:hover,
  .filter-input.ant-input-affix-wrapper:focus-within {
    border-color: ${COLORS.PRIMARY} !important;
    box-shadow: none !important;
  }

  /* Align search icon perfectly */
  .filter-input .ant-input-prefix {
    margin-right: 6px;
  }

  /* ✅ INPUT FIX */
  .filter-input.ant-input-affix-wrapper {
    border-radius: 20px !important;
    height: 38px !important;
    display: flex;
    align-items: center;
    padding: 0 11px;
    border: 1px solid #d9d9d9;
  }

  .filter-input.ant-input-affix-wrapper .ant-input {
    border: none !important;
    box-shadow: none !important;
  }

  .filter-input .ant-select-selector {
    border-radius: 20px !important;
    height: 38px !important;
    display: flex;
    align-items: center;
  }

  .filter-input.ant-input-affix-wrapper:hover,
  .filter-input.ant-input-affix-wrapper:focus-within,
  .filter-input .ant-select-selector:hover,
  .ant-select-focused .ant-select-selector {
    border-color: ${COLORS.PRIMARY} !important;
    box-shadow: none !important;
  }
`;

const DropdownWrap = styled.div`
  .ant-dropdown-menu {
    border-radius: 10px;
    padding: 6px;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
  }

  .ant-dropdown-menu-item {
    padding: 10px 14px;
    border-radius: 6px;

    &:hover {
      background: #f5f5f5;
    }
  }
`;

const Client = () => {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [filters, setFilters] = useState({
        search: "",
        clientType: "",
        status: "",
        country: "",
    });
    const history = useHistory();
    const csvLinkRef = useRef();
    const userList = useSelector(getUserList);
    const formatDate = (date) => {
        const day = new Date(date).getDate();
        const month = new Date(date).toLocaleString("en-US", { month: "short" });
        const year = new Date(date).getFullYear();

        const getDaySuffix = (day) => {
            if (day > 3 && day < 21) return "th";
            switch (day % 10) {
                case 1: return "st";
                case 2: return "nd";
                case 3: return "rd";
                default: return "th";
            }
        };

        return `${day}${getDaySuffix(day)} ${month} ${year}`;
    };
    const csvData = Array.isArray(data)
        ? data.map((item) => {
            const matchedUser = userList?.find(
                (user) =>
                    user?.userid?.toLowerCase() === (item?.createdby?.toLowerCase() || item?.createdBy?.toLowerCase())
            );

            return {
                "Client Name": item.name,
                "Client Type": item.type,
                "Country": item.country,
                "Client ID": item.id,
                "Email": item.email,
                "Status": item.status,
                "Created By": matchedUser?.fullname || item?.createdby || item?.createdBy || "",
                // "Created Date": item.createdDate || "",
            };
        })
        : [];

    useEffect(() => {
        const hasFilters =
            filters.search ||
            filters.clientType ||
            filters.status ||
            filters.country;

        if (hasFilters) {
            filterClients();
        } else {
            getClients();
        }
    }, [filters]);

    const allDataRef = useRef([]);

    const getClients = async () => {
        try {
            setLoading(true);

            const response = await CALL_API(
                "/insyts-legal/getalllegalclients",
                "post",
            );
            if (response?.code === "SUCCESS") {
                const formattedData = response?.data?.map((item, index) => ({
                    key: item?.bdo_id || index,
                    originalData: item,
                    name:
                        item?.clienttype === "person"
                            ? item?.clientname
                            : item?.companyregisteredname,
                    type: item?.clienttype ? item?.clienttype.charAt(0).toUpperCase() + item?.clienttype.slice(1) : "-",
                    country: item?.country,
                    id: item?.bdo_id,
                    email: item?.officialemail,
                    status: item?.statusname === "active" ? "Active" : "Inactive",
                    createdby: item?.createdby || item?.createdBy,
                    createdDate: kenyaFormatDateTime(item?.createdat || item?.createdAt) || "",
                }));

                setData(formattedData || []);
                allDataRef.current = formattedData || [];
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const addClientMenu = {
        items: [
            {
                key: "new",
                label: "New Client",
                onClick: () => history.push("/client-new"),
            },
            {
                key: "pending",
                label: "Pending Client",
                onClick: () => history.push("/pending-client"),
            },
        ],
    };

    const handleEdit = (record) => {
        history.push({
            pathname: `/client-new/${record.key}`,
            state: { editData: record.originalData, editMode: true },
        });
    };

    const handleFilterChange = (key, value) => {
        setFilters((prev) => ({
            ...prev,
            [key]: value,
        }));
    };

    const buildQueryParams = () => {
        const params = new URLSearchParams();

        if (filters.search) params.append("search", filters.search); // ✅ ADD THIS
        if (filters.clientType) params.append("clienttype", filters.clientType); // ⚠️ match backend
        if (filters.status) params.append("status", filters.status);
        if (filters.country) params.append("managingoffice", filters.country);

        return params.toString();
    };

    const filterClients = async () => {
        try {
            setLoading(true);

            const query = buildQueryParams();

            const response = await CALL_API(
                `/insyts-legal/filterlegalclients?${query}`,
                "get"
            );
            if (response?.code === "SUCCESS") {
                const formattedData = response?.data?.map((item, index) => ({
                    key: item?.clientId || index,
                    originalData: {
                        clienttype: item?.clientType ? item?.clientType.charAt(0).toUpperCase() + item?.clientType.slice(1) : "-",
                        companyregisteredname:
                            item?.clientType === "company" ? item?.clientName : undefined,
                        clientname:
                            item?.clientType === "person" ? item?.clientName : undefined,

                        owner: item?.createdBy,
                        officialemail: item?.email,
                        phone: item?.phone || "",
                        primaryindustry: item?.primaryindustry || "",
                        companywebsiteurl: item?.companywebsiteurl || "",

                        primarycontactperson: item?.primarycontactperson || "",
                        primarycontactemail: item?.primarycontactemail || "",

                        registeredaddress: item?.registeredaddress || "",
                        city: item?.city || "",
                        state: item?.state || "",
                        zipcode: item?.zipcode || "",

                        country: item?.managingoffice,
                        statusname: item?.status,
                        bdo_id: item?.clientId,
                    },
                    name: item?.clientName,
                    type: item?.clientType ? item?.clientType.charAt(0).toUpperCase() + item?.clientType.slice(1) : "-",
                    country: item?.managingoffice,
                    id: item?.clientId,
                    email: item?.email,
                    status: item?.status === "active" ? "Active" : "Inactive",
                    createdby: item?.createdby || item?.createdBy,
                    createdDate: kenyaFormatDateTime(item?.createdat || item?.createdAt) || "",
                }));

                setData(formattedData || []);
            }
        } catch (err) {
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const userClientId = useSelector(getClientid);
    const [encryptedClientId, setEncryptedClientId] = useState("");

    useEffect(() => {
        const encryptId = async () => {
            if (userClientId) {
                const result = await encrypt(String(userClientId));
                setEncryptedClientId(result);
            }
        };
        encryptId();
    }, [userClientId]);

    const linkToCopy = `onboardingclient.legal.insyts.ai/?id=${encryptedClientId}`;

    const handleCopyClick = () => {
        navigator.clipboard
            .writeText(linkToCopy)
            .then(() => {
                message.success("Link copied");
            })
            .catch(() => {
                message.error("Failed to copy link");
            });
    };



    const columns = [
        { title: "Client Name", dataIndex: "name" },
        { title: "Client Type", dataIndex: "type" },
        { title: "Country", dataIndex: "country" },
        { title: "Client ID", dataIndex: "id" },
        { title: "Email", dataIndex: "email" },
        {
            title: "Status",
            dataIndex: "status",
            render: (text) => (
                <span
                    className={text === "Active" ? "status-active" : "status-inactive"}
                >
                    {text}
                </span>
            ),
        },
        {
            title: "Created By",
            render: (_, record) => {
                const matchedUser = userList?.find(
                    (user) =>
                        user?.userid?.toLowerCase() === (record?.createdby?.toLowerCase() || record?.createdBy?.toLowerCase())
                );

                return (
                    <div>
                        <div>
                            {matchedUser?.fullname || record?.createdby || record?.createdBy || "N/A"}
                        </div>
                        <small
                            style={{
                                color: "#888",
                                fontSize: "12px", // increased date font size
                            }}
                        >
                            {record?.createdDate || ""}
                        </small>
                    </div>
                );
            },
        },
        {
            title: "Action",
            key: "action",
            width: 80,
            render: (_, record) => (
                <EditOutlined
                    style={{
                        color: "#00685F",
                        cursor: "pointer",
                        background: "#deefee",
                        padding: "2px",
                        borderRadius: "4px",
                        height: "35px",
                        width: "35px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: 18
                    }}
                    className="action-icon"
                    onClick={(e) => {
                        e.stopPropagation();
                        handleEdit(record);
                    }}
                />
            ),
        },
    ];

    return (
        <ClientWrap>
            <div className="header">
                <div className="title">Client</div>

                <div className="d-flex gap-4 mb-3">
                    {data?.length > 0 &&
                        <Button className="export-btn" style={{ borderRadius: "6px", border: "1px solid black" }} onClick={() => csvLinkRef.current.link.click()}>
                            Export CSV File
                        </Button>
                    }
                    <CSVLink
                        data={csvData || []}
                        filename="clients.csv"
                        ref={csvLinkRef}
                        style={{ display: "none" }}
                    />
                    <LinkOutlined
                        onClick={handleCopyClick}
                        className="btn-matter"
                        style={{
                            fontSize: "18px",
                            cursor: "pointer",
                            padding: "6px",
                            borderRadius: "6px",
                            background: COLORS.PRIMARY,
                            display: "flex",
                            alignItems: "center",
                            color: "#ffffff !important",

                        }}
                        title="Copy Link"
                    />

                    <DropdownWrap>
                        <Dropdown
                            menu={addClientMenu}
                            trigger={["click"]}
                            placement="bottomRight"
                        >
                            <Button
                                // type="primary"
                                className="btn-matter"
                                style={{
                                    background: COLORS.PRIMARY,
                                    borderRadius: "6px",
                                    color: "#ffffff !important",
                                }}
                            >
                                Add Client
                            </Button>
                        </Dropdown>
                    </DropdownWrap>
                </div>
            </div>

            {/* Filters */}
            <div className="filters-header">
                <div className="total-count">Total Clients: {data?.length || 0}</div>

                <div className="filters">
                    <Input
                        placeholder="Client"
                        prefix={<SearchOutlined />}
                        className="filter-input"
                        onChange={(e) => handleFilterChange("search", e.target.value)}
                        allowClear
                    />

                    <Select
                        placeholder="Client Type"
                        className="filter-input"
                        onChange={(val) => handleFilterChange("clientType", val)}
                        allowClear
                    >
                        <Option value="company">Company</Option>
                        <Option value="person">Person</Option>
                    </Select>

                    <Select
                        placeholder="Status"
                        className="filter-input"
                        onChange={(val) => handleFilterChange("status", val)}
                        allowClear
                    >
                        <Option value="active">Active</Option>
                        <Option value="inactive">Inactive</Option>
                    </Select>

                    <Select
                        placeholder="Country"
                        className="filter-input"
                        onChange={(val) => handleFilterChange("country", val)}
                        allowClear
                    >
                        {[...new Set(allDataRef.current.map((item) => item.country).filter(Boolean))].map((country) => (
                            <Option key={country} value={country}>
                                {country}
                            </Option>
                        ))}
                    </Select>

                </div>
            </div>

            <Table
                columns={columns}
                dataSource={data}
                loading={loading}
                size="small"
                pagination={{ pageSize: 10 }}
                onRow={(record) => ({
                    onClick: () =>
                        history.push({
                            pathname: `/client-detail/${record.key}`,
                            state: { clientData: record.originalData },
                        }),
                    style: { cursor: "pointer" },
                })}
            />
        </ClientWrap>
    );
};

export default Client;
